(function() {
    'use strict';

    angular
        .module('functional7App')
        .controller('ProgramaDialogController', ProgramaDialogController);

    ProgramaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Programa', 'Ejercicio', 'Media'];

    function ProgramaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Programa, Ejercicio, Media) {
        var vm = this;

        vm.programa = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.ejercicios = Ejercicio.query();
        vm.media = Media.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.programa.id !== null) {
                Programa.update(vm.programa, onSaveSuccess, onSaveError);
            } else {
                Programa.save(vm.programa, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('functional7App:programaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.modificado = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
